import { isString } from '@guardian/libs';
import { getAdvertById } from '../dfp/get-advert-by-id';
const ineligiblePassbacks = ['teadsdesktop', 'teadsmobile', 'teads'];
const passbackRefresh = (specs, adSlot) => {
    const advert = getAdvertById(adSlot.id);
    if (advert) {
        advert.slot.setConfig({
            targeting: {
                passback: specs,
            },
        });
        // passbacks with these values are not eligible for teads
        if (ineligiblePassbacks.includes(specs)) {
            advert.slot.setConfig({
                targeting: {
                    teadsEligible: 'false',
                },
            });
        }
        advert.refresh();
    }
};
const init = (register) => {
    register('passback-refresh', (specs, _, iframe) => {
        if (iframe && isString(specs)) {
            const adSlot = iframe.closest('.js-ad-slot') ?? undefined;
            if (!adSlot) {
                return;
            }
            return passbackRefresh(specs, adSlot);
        }
    });
};
export const _ = { passbackRefresh };
export { init };
